import axios from 'axios';
import returnDomenLocation from '../helpers/returnDomainLoc';
import microserverConfig from '../helpers/microserverConfig';

const config = () => ({
  baseURL: returnDomenLocation('offers-clusters'),
});

export default microserverConfig(axios.create(config()));
